import React from 'react';
import { TYPE_EVENT_CLICK } from '../utils/consts';
import { sendStat } from './sendStat';

export const useClickStat = () => {
  const onClick = (e: any) => {
    const nodes = e?.path;
    if (Array.isArray(nodes)) {
      const isButton = nodes[0]?.nodeName === 'BUTTON' || nodes[1]?.nodeName === 'BUTTON' || nodes[1]?.nodeName === 'LI';
      if (isButton) {
        sendStat(TYPE_EVENT_CLICK);
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
};
